import { render, staticRenderFns } from "./DashboardNewsletter.vue?vue&type=template&id=9f31de34"
import script from "./DashboardNewsletter.vue?vue&type=script&lang=js"
export * from "./DashboardNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports